<template>
    <div class="container">
        <div class="row">
            <div class="d-flex align-items-center">
                <Backlink :back="$router.options.history.state.back" />
                <h2 class="mx-1 mb-4">Information de l'utilisateur connecté</h2>
            </div>
        </div>
        <div class="row mt-3">
            <div class="card">
                <div class="card-body">
                    <div class="row d-flex">
                        <div class="col">
                            <h3>
                                <i class="bi bi-person"></i>
                                {{ userStore.$state.user.name }} {{ userStore.$state.user.prenoms }}
                            </h3>
                        </div>
                        <div class="col text-end">

                            <button class="btn btn-secondary ms-auto" data-bs-toggle="modal"
                                data-bs-target="#editUserInfo">
                                <i class="bi bi-pencil-square"></i>
                                Modifer</button>
                        </div>
                        <modal m-title="" idx="editUserInfo" :dismiss="dismissEditUser">
                            <UserForm :user_id="userStore.$state.user.id" :item="userStore.$state.user"
                                @save="userEdited" @edit="userEdited" />
                        </modal>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12 col-md-6 mt-3">
                            <p class="card-text">
                                <span class="text-muted">Télephone: </span>
                                <span class="fw-bold">{{ formatPhone(userStore.$state.user.telephone ?? '') }}</span>
                            </p>
                            <p class="card-text">
                                <span class="text-muted">Email: </span>
                                <span class="fw-bold">{{ userStore.$state.user.email ?? 'Non défini' }}</span>
                            </p>
                        </div>
                        <div class="col-12 col-md-6 mt-3">
                            <p class="card-text">
                                <span class="text-muted">Adresse: </span>
                                <span class="fw-bold">{{ userStore.$state.user.adresse ?? 'Non défini' }}</span>
                            </p>
                            <p class="card-text">
                                <span class="text-muted">Ajouter depuis: </span>
                                <span class="fw-bold">{{ formatDate(userStore.$state.user.created_at) }}</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <card header="Role et permissions">
                <template #body>
                    <div>
                        <div class="row d-flex justify-content-between align-items-center">
                            <div class="col">
                                <p class="card-text">
                                    <span class="fw-bold p-2 badge badge-lg bg-info fs-4 text-uppercase">{{
                                        userStore.$state.user.roleInfo?.long_name }}</span>
                                </p>
                            </div>
                            <div class="col text-end">
                                <button class="btn btn-secondary">
                                    <i class="bi bi-pencil-square"></i>
                                    Modifer</button>
                            </div>

                        </div>
                        <ul class="list-group list-group-flush" v-if="userStore.$state.user.roleInfo">
                            <li class="list-group-item" v-for="role in userStore.$state.user.roleInfo.permissions"
                                :key="'role' + role.id">
                                <div class="card-text">
                                    <span class="fw-bold">{{ role.long_name ?? 'Non défini' }}: </span>
                                    <p class="text-muted">{{ role.description }}</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </template>
            </card>
        </div>
    </div>
</template>

<script>
import { useUserStore } from '@/store/userStore';
import { formatDate } from '@/helpers/dateFormater';
import { formatPhone } from '@/helpers/textFormater';
import Card from '@/components/elements/Card.vue';
import Modal from '@/components/modals/Modal.vue';
import UserForm from '@/components/forms/UserForm.vue';
import { fetchUser } from '@/helpers/userMethods';
import Backlink from '@/components/partials/Backlink.vue';

export default {
    name: "Me",
    components: {
        Card,
        Modal,
        UserForm,
        Backlink
    },
    data: () => ({
        dismissEditUser: 0
    }),
    computed: {
        userStore: () => useUserStore(),
    },
    methods: {
        formatDate,
        formatPhone,
        fetchUser,
        userEdited() {
            this.dismissEditUser++
            this.fetchUser()
        }
    }
}
</script>